import classNames from 'classnames';
import React from 'react';
import styles from './styles.module.scss';

const Spinner = ({ className, ...rest }) => {
  return (
    <>
      <div className={classNames(styles.wrapper, className)} {...rest}>
        <div className={styles.loader} />
      </div>
    </>
  );
};

export default Spinner;
